import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import { styles, colors, radius } from '../../styles/theme';
import { invalidateQueries } from '../../hooks/useCachedQuery';
import { logError } from '../../utils/logError';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';

const getAuthHeaders = () => {
  const token = localStorage.getItem('access_token');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

const TalepOlusturPage = () => {
  const navigate = useNavigate();

  const [malzemeler, setMalzemeler] = useState([]);
  const [lokasyonlar, setLokasyonlar] = useState([]);
  const [message, setMessage] = useState('');
  const [serbestYazim, setSerbestYazim] = useState(false);
  const [talepForm, setTalepForm] = useState({
    lokasyon_id: '',
    malzeme_id: '',
    serbest_urun_ad: '',
    miktar: 100,
    birim: 'kg',
    açıklama: ''
  });

  useEffect(() => {
    fetch(`${API_URL}/api/malzemeler`, { headers: getAuthHeaders() })
      .then(res => res.json())
      .then(data => setMalzemeler(Array.isArray(data) ? data : []))
      .catch(logError);

    fetch(`${API_URL}/api/lokasyonlar`, { headers: getAuthHeaders() })
      .then(res => res.json())
      .then(data => setLokasyonlar(Array.isArray(data) ? data : []))
      .catch(logError);
  }, []);

  const handleCreateTalep = async () => {
    if (!talepForm.lokasyon_id) {
      alert('Lokasyon seçiniz');
      return;
    }
    if (!serbestYazim && !talepForm.malzeme_id) {
      alert('Malzeme seçiniz veya serbest yazim modunu kullaniniz');
      return;
    }
    if (serbestYazim && !talepForm.serbest_urun_ad.trim()) {
      alert('Urun adini yaziniz');
      return;
    }

    try {
      const payload = {
        lokasyon_id: parseInt(talepForm.lokasyon_id),
        malzeme_id: serbestYazim ? null : parseInt(talepForm.malzeme_id),
        serbest_urun_ad: serbestYazim ? talepForm.serbest_urun_ad.trim() : null,
        miktar: talepForm.miktar,
        birim: talepForm.birim,
        açıklama: talepForm.açıklama
        // talep_eden backend'de current_user'dan alınır (SA-02) — client göndermez
      };

      const res = await fetch(`${API_URL}/api/talepler`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
        body: JSON.stringify(payload)
      });

      if (res.ok) {
        const data = await res.json();
        invalidateQueries(['talep', 'dashboard', 'siparis']);
        setMessage(`Talep ${data.talep_no || ''} başarıyla oluşturuldu!`);
        setTalepForm({ lokasyon_id: '', malzeme_id: '', serbest_urun_ad: '', miktar: 100, birim: 'kg', açıklama: '' });
        setSerbestYazim(false);
        setTimeout(() => setMessage(''), 3000);
      } else {
        const err = await res.json().catch(() => ({}));
        alert(err.detail || 'Talep olusturulamadi');
      }
    } catch (err) {
      logError(err);
      alert('Baglanti hatası');
    }
  };

  return (
    <div>
      <Header title="Yeni Talep Oluştur" />
      <div style={{ padding: '20px', background: colors.background, minHeight: 'calc(100vh - 60px)' }}>
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          {message && (
            <div style={{ background: '#d4edda', padding: '15px', marginBottom: '20px', borderRadius: radius.sm, color: '#155724', borderLeft: `4px solid ${styles.success}` }}>
              {message}
            </div>
          )}

          <div style={{ background: colors.surface, padding: '30px', borderRadius: radius.md }}>
            {/* Lokasyon */}
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Lokasyon</label>
              <select
                value={talepForm.lokasyon_id}
                onChange={(e) => setTalepForm({ ...talepForm, lokasyon_id: e.target.value })}
                style={{ width: '100%', padding: '12px', border: '2px solid #e0e0e0', borderRadius: radius.sm, fontSize: '15px' }}
              >
                <option value="">Seçiniz</option>
                {lokasyonlar.map(l => (
                  <option key={l.id} value={l.id}>{l.ad} ({l.tip})</option>
                ))}
              </select>
            </div>

            {/* Malzeme / Serbest Yazim Toggle */}
            <div style={{ marginBottom: '20px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                <label style={{ fontWeight: 'bold' }}>Urun</label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', cursor: 'pointer', color: styles.primary }}>
                  <input
                    type="checkbox"
                    checked={serbestYazim}
                    onChange={(e) => {
                      setSerbestYazim(e.target.checked);
                      if (e.target.checked) {
                        setTalepForm({ ...talepForm, malzeme_id: '' });
                      } else {
                        setTalepForm({ ...talepForm, serbest_urun_ad: '' });
                      }
                    }}
                  />
                  Listede yok, serbest yazayim
                </label>
              </div>

              {serbestYazim ? (
                <input
                  type="text"
                  value={talepForm.serbest_urun_ad}
                  onChange={(e) => setTalepForm({ ...talepForm, serbest_urun_ad: e.target.value })}
                  placeholder="Urun adini yaziniz... (orn: Coca Cola 330ml, Peynir kasar)"
                  style={{ width: '100%', padding: '12px', border: '2px solid #e0e0e0', borderRadius: radius.sm, fontSize: '15px', boxSizing: 'border-box' }}
                />
              ) : (
                <select
                  value={talepForm.malzeme_id}
                  onChange={(e) => setTalepForm({ ...talepForm, malzeme_id: e.target.value })}
                  style={{ width: '100%', padding: '12px', border: '2px solid #e0e0e0', borderRadius: radius.sm, fontSize: '15px' }}
                >
                  <option value="">Malzeme Seçiniz...</option>
                  {malzemeler.map(m => (
                    <option key={m.id} value={m.id}>{m.ad} ({m.birim})</option>
                  ))}
                </select>
              )}
            </div>

            {/* Miktar + Birim */}
            <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '15px', marginBottom: '20px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Miktar</label>
                <input
                  type="number"
                  value={talepForm.miktar}
                  onChange={(e) => setTalepForm({ ...talepForm, miktar: parseFloat(e.target.value) })}
                  style={{ width: '100%', padding: '12px', border: '2px solid #e0e0e0', borderRadius: radius.sm, fontSize: '15px', boxSizing: 'border-box' }}
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Birim</label>
                <select
                  value={talepForm.birim}
                  onChange={(e) => setTalepForm({ ...talepForm, birim: e.target.value })}
                  style={{ width: '100%', padding: '12px', border: '2px solid #e0e0e0', borderRadius: radius.sm, fontSize: '15px' }}
                >
                  <option value="kg">kg</option>
                  <option value="adet">Adet</option>
                  <option value="paket">Paket</option>
                  <option value="lt">Lt</option>
                  <option value="koli">Koli</option>
                  <option value="kutu">Kutu</option>
                </select>
              </div>
            </div>

            {/* Açıklama */}
            <div style={{ marginBottom: '25px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Açıklama (Opsiyonel)</label>
              <textarea
                value={talepForm.açıklama}
                onChange={(e) => setTalepForm({ ...talepForm, açıklama: e.target.value })}
                rows={3}
                style={{ width: '100%', padding: '12px', border: '2px solid #e0e0e0', borderRadius: radius.sm, fontSize: '15px', boxSizing: 'border-box', resize: 'vertical' }}
                placeholder="Ek açıklama..."
              />
            </div>

            {/* Butonlar */}
            <div style={{ display: 'flex', gap: '15px' }}>
              <button
                onClick={handleCreateTalep}
                style={{ flex: 1, padding: '14px', background: styles.primary, color: 'white', border: 'none', borderRadius: radius.sm, fontWeight: 'bold', fontSize: '16px', cursor: 'pointer' }}
              >
                TALEP OLUSTUR
              </button>
              <button
                onClick={() => navigate('/dashboard')}
                style={{ flex: 1, padding: '14px', background: '#e0e0e0', color: styles.secondary, border: 'none', borderRadius: radius.sm, fontWeight: 'bold', fontSize: '16px', cursor: 'pointer' }}
              >
                IPTAL
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TalepOlusturPage;
